export default __webpack_public_path__ + "static/media/rbi.3b17be8a.jpg";